import React from 'react';
import './LoginPage.css';
import './kioskTheme.css';
import SupportRequestForm from './SupportRequestForm';

const TroubleLoginPage = () => {
    return (
        <div className="login-page kiosk-theme lg-page">
            <SupportRequestForm />
        </div>
    );
};

export default TroubleLoginPage;
